import common from '../../common';

export default class FocusOverlay extends PIXI.Container {
	constructor() {
		super();

		/**
		 * @type {PIXI.Graphics[]}
		 */
		this._boxes = [];

		/**
		 * @type {PIXI.Rectangle}
		 */
		this._savedBounds = new PIXI.Rectangle();

		/**
		 * @type {PIXI.Sprite}
		 */
		this._savedSprite = null;

		/**
		 * @type {Boolean}
	 	 */
		this._keepSpriteFocused = false;

		this._gradientTexture = null;

		this.init();
	}

	init() {
		for (let i = 0; i < 4; i++) {
			const g = new PIXI.Graphics();

			g.beginFill(0x0);
			g.drawRect(0, 0, 50, 50);
			g.endFill();
			g.alpha = 0.5;
			g.interactive = true;
			this.addChild(g);

			this._boxes.push(g);
		}

		this._gradientTexture = new PIXI.mesh.NineSlicePlane(P3.assets.texture('ui_darkening_layer'), 95, 95, 95, 95);
		this._gradientTexture.width = 128;
		this._gradientTexture.height = 128;
		this._gradientTexture.alpha = 0.5;
		this.addChild(this._gradientTexture);

		this.setFocus(new PIXI.Rectangle(100, 100, 100, 100));
	}

	destroy() {
	}

	resize() {
		this.x = (common.STAGE_WIDTH - P3.View.width) * 0.5;
		this.setFocus(this._savedBounds);
	}

	update() {
		if (this._keepSpriteFocused && this._savedSprite) {
			this.focusSprite(this._savedSprite, true);
		}
	}

	/**
	 * @param {PIXI.Rectangle|number} rect The bounds of the clear area of the focus. Defined as a PIXI.Rectangle with x, y, width and height parameters
	 * @param {number} y
	 * @param {number} width
	 * @param {number} height
	 */
	setFocus(rect, y = 0, width = 0, height = 0) {
		this._keepSpriteFocused = false;
		this._savedSprite = null;

		// if we were passed 4 numbers instead of a PIXI.Rectangle, create one.
		const padding = 40;
		rect = rect instanceof PIXI.Rectangle ? rect : new PIXI.Rectangle(rect, y, width, height);
		rect.pad(padding);

		this._savedBounds.copy(rect);

		const b1 = this._boxes[0];
		const b2 = this._boxes[1];
		const b3 = this._boxes[2];
		const b4 = this._boxes[3];

		b1.width = rect.x;
		b1.height = rect.y + rect.height;

		b2.x = b1.width;
		b2.width = P3.View.width - b2.x;
		b2.height = rect.y;

		b3.x = rect.x + rect.width;
		b3.y = rect.y;
		b3.width = P3.View.width - b3.x;
		b3.height = P3.View.height - b3.y;

		b4.y = rect.y + rect.height;
		b4.width = rect.x + rect.width;
		b4.height = P3.View.height - b4.y;

		this._gradientTexture.width = rect.width;
		this._gradientTexture.height = rect.height;
		this._gradientTexture.position.x = rect.x;
		this._gradientTexture.position.y = rect.y;
	}

	/**
	 * @param {PIXI.Sprite} sprite
	 * @param {boolean} keepFocused
	 */
	focusSprite(sprite, keepFocused = false) {
		this._savedSprite = null;
		this._keepSpriteFocused = false;

		if (keepFocused) {
			this._savedSprite = sprite;
			this._keepSpriteFocused = true;
		}

		// magic
		this.setFocus(new PIXI.Rectangle(
			sprite.x - (sprite.width * 0.5) - ((common.STAGE_WIDTH - P3.View.width) * 0.5),
			sprite.y - (sprite.height * 0.5),
			sprite.width,
			sprite.height
		));
	}
}
